import React, { useEffect, useState } from "react";
import { styled, makeStyles } from "@material-ui/core/styles";

import Button from "../../components/CustomButtons/Button";
import InputLabel from "@material-ui/core/InputLabel";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import Link from "@material-ui/core/Link";
import GridItem from "../../components/Grid/GridItem.jsx";
import * as CMBYN from "../../constants/api";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { TextField, Typography } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

import tooltipStyle from "../../assets/jss/material-dashboard-react/tooltipStyle.js";

const useTooltipStyles = makeStyles(tooltipStyle);

const BootstrapInput = styled(InputBase)(({ theme }) => ({
	"label + &": {
		marginTop: theme.spacing(2),
	},
	"& .MuiInputBase-input": {
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		border: "1px solid #ced4da",
		fontSize: 16,
		padding: "10px 26px 10px 12px",
		width: "150px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:focus": {
			borderRadius: 4,
			borderColor: "#80bdff",
			boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
		},
	},
}));

export default function CropSpeciesPopup(props) {
	const tooltipClasses = useTooltipStyles();
	const {
		fieldDetails,

		parentPreCropOneYearOneChange,
		parentPreCropOneYearTwoChange,
		parentPreCropOneYearThreeChange,
		parentPreCropTwoYearOneChange,
		parentPreCropTwoYearTwoChange,
		parentPreCropTwoYearThreeChange,
		parentPreCropThreeYearOneChange,
		parentPreCropThreeYearTwoChange,
		parentPreCropThreeYearThreeChange,
		parentPostcropOneYearOneChange,
		parentPostcropOneYearTwoChange,
		parentPostcropOneYearThreeChange,
		parentPostcropTwoYearOneChange,
		parentPostcropTwoYearTwoChange,
		parentPostcropTwoYearThreeChange,
		parentPostcropThreeYearOneChange,
		parentPostcropThreeYearTwoChange,
		parentPostcropThreeYearThreeChange,

		parentCopyPreCrop1VerticalChange,
		parentCopyPreCrop2VerticalChange,
		parentCopyPreCrop3VerticalChange,
		parentCopyPostCrop1VerticalChange,
		parentCopyPostCrop2VerticalChange,
		parentCopyPostCrop3VerticalChange,

		handleCropAgeChange,
	} = props;

	const [cropList, setCropList] = React.useState([]);
	const [hasMultiplePreCrops, setHasMultiplePreCrops] = useState(propsHasMultipleCrops(true));
	const [hasMultiplePostCrops, setHasMultiplePostCrops] = useState(propsHasMultipleCrops(false));

	const [preCropOneYear1, setPreCropOneYear1] = useState(fieldDetails.precropping.preyearcroponeyearone);
	const [preCropTwoYear1, setPreCropTwoYear1] = useState(fieldDetails.precropping.preyearcroptwoyearone);
	const [preCropThreeYear1, setPreCropThreeYear1] = useState(fieldDetails.precropping.preyearcropthreeyearone);
	const [preCropOneYear2, setPreCropOneYear2] = useState(fieldDetails.precropping.preyearcroponeyeartwo);
	const [preCropTwoYear2, setPreCropTwoYear2] = useState(fieldDetails.precropping.preyearcroptwoyeartwo);
	const [preCropThreeYear2, setPreCropThreeYear2] = useState(fieldDetails.precropping.preyearcropthreeyeartwo);
	const [preCropOneYear3, setPreCropOneYear3] = useState(fieldDetails.precropping.preyearcroponeyearthree);
	const [preCropTwoYear3, setPreCropTwoYear3] = useState(fieldDetails.precropping.preyearcroptwoyearthree);
	const [preCropThreeYear3, setPreCropThreeYear3] = useState(fieldDetails.precropping.preyearcropthreeyearthree);
	const [postCropOneYear1, setPostCropOneYear1] = useState(fieldDetails.postcropping.postyearcroponeyearone);
	const [postCropTwoYear1, setPostCropTwoYear1] = useState(fieldDetails.postcropping.postyearcroptwoyearone);
	const [postCropThreeYear1, setPostCropThreeYear1] = useState(fieldDetails.postcropping.postyearcropthreeyearone);
	const [postCropOneYear2, setPostCropOneYear2] = useState(fieldDetails.postcropping.postyearcroponeyeartwo);
	const [postCropTwoYear2, setPostCropTwoYear2] = useState(fieldDetails.postcropping.postyearcroptwoyeartwo);
	const [postCropThreeYear2, setPostCropThreeYear2] = useState(fieldDetails.postcropping.postyearcropthreeyeartwo);
	const [postCropOneYear3, setPostCropOneYear3] = useState(fieldDetails.postcropping.postyearcroponeyearthree);
	const [postCropTwoYear3, setPostCropTwoYear3] = useState(fieldDetails.postcropping.postyearcroptwoyearthree);
	const [postCropThreeYear3, setPostCropThreeYear3] = useState(fieldDetails.postcropping.postyearcropthreeyearthree);

	const [preCropAges, setPreCropAges] = useState(fieldDetails.precropping.cropAges ?? ["", "", ""]); //re-defining the initial values here for backward compatibility with old project files
	const [postCropAges, setPostCropAges] = useState(fieldDetails.postcropping.cropAges ?? ["", "", ""]);

	const cropYearPeriods = {
		Pre: [
			[
				{
					crop: preCropOneYear1,
					changeHandler: (event) => {
						setPreCropOneYear1(event.target.value);
						parentPreCropOneYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PreCrop1Year2").value = preCropOneYear1;
						setPreCropOneYear2(preCropOneYear1);

						document.getElementById("PreCrop1Year3").value = preCropOneYear1;
						setPreCropOneYear3(preCropOneYear1);

						parentCopyPreCrop1VerticalChange(preCropOneYear1);
					},
				},
				{
					crop: preCropTwoYear1,
					changeHandler: (event) => {
						setPreCropTwoYear1(event.target.value);
						parentPreCropTwoYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PreCrop2Year2").value = preCropTwoYear1;
						setPreCropTwoYear2(preCropTwoYear1);
						document.getElementById("PreCrop2Year3").value = preCropTwoYear1;
						setPreCropTwoYear3(preCropTwoYear1);

						parentCopyPreCrop2VerticalChange(preCropTwoYear1);
					},
				},
				{
					crop: preCropThreeYear1,
					changeHandler: (event) => {
						setPreCropThreeYear1(event.target.value);
						parentPreCropThreeYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PreCrop3Year2").value = preCropThreeYear1;
						setPreCropThreeYear2(preCropThreeYear1);
						document.getElementById("PreCrop3Year3").value = preCropThreeYear1;
						setPreCropThreeYear3(preCropThreeYear1);
						parentCopyPreCrop3VerticalChange(preCropThreeYear1);
					},
				},
			],
			[
				{
					crop: preCropOneYear2,
					changeHandler: (event) => {
						setPreCropOneYear2(event.target.value);
						parentPreCropOneYearTwoChange(event.target.value);
					},
				},
				{
					crop: preCropTwoYear2,
					changeHandler: (event) => {
						setPreCropTwoYear2(event.target.value);
						parentPreCropTwoYearTwoChange(event.target.value);
					},
				},
				{
					crop: preCropThreeYear2,
					changeHandler: (event) => {
						setPreCropThreeYear2(event.target.value);
						parentPreCropThreeYearTwoChange(event.target.value);
					},
				},
			],
			[
				{
					crop: preCropOneYear3,
					changeHandler: (event) => {
						setPreCropOneYear3(event.target.value);
						parentPreCropOneYearThreeChange(event.target.value);
					},
				},
				{
					crop: preCropTwoYear3,
					changeHandler: (event) => {
						setPreCropTwoYear3(event.target.value);
						parentPreCropTwoYearThreeChange(event.target.value);
					},
				},
				{
					crop: preCropThreeYear3,
					changeHandler: (event) => {
						setPreCropThreeYear3(event.target.value);
						parentPreCropThreeYearThreeChange(event.target.value);
					},
				},
			],
		],
		Post: [
			[
				{
					crop: postCropOneYear1,
					changeHandler: (event) => {
						setPostCropOneYear1(event.target.value);
						parentPostcropOneYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PostCrop1Year2").value = postCropOneYear1;
						setPostCropOneYear2(postCropOneYear1);

						document.getElementById("PostCrop1Year3").value = postCropOneYear1;
						setPostCropOneYear3(postCropOneYear1);

						parentCopyPostCrop1VerticalChange(postCropOneYear1);
					},
				},
				{
					crop: postCropTwoYear1,
					changeHandler: (event) => {
						setPostCropTwoYear1(event.target.value);
						parentPostcropTwoYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PostCrop2Year2").value = postCropTwoYear1;
						setPostCropTwoYear2(postCropTwoYear1);
						document.getElementById("PostCrop2Year3").value = postCropTwoYear1;
						setPostCropTwoYear3(postCropTwoYear1);

						parentCopyPostCrop2VerticalChange(postCropTwoYear1);
					},
				},
				{
					crop: postCropThreeYear1,
					changeHandler: (event) => {
						setPostCropThreeYear1(event.target.value);
						parentPostcropThreeYearOneChange(event.target.value);
					},
					copyHandler: (event) => {
						document.getElementById("PostCrop3Year2").value = postCropThreeYear1;
						setPostCropThreeYear2(postCropThreeYear1);
						document.getElementById("PostCrop3Year3").value = postCropThreeYear1;
						setPostCropThreeYear3(postCropThreeYear1);
						parentCopyPostCrop3VerticalChange(postCropThreeYear1);
					},
				},
			],
			[
				{
					crop: postCropOneYear2,
					changeHandler: (event) => {
						setPostCropOneYear2(event.target.value);
						parentPostcropOneYearTwoChange(event.target.value);
					},
				},
				{
					crop: postCropTwoYear2,
					changeHandler: (event) => {
						setPostCropTwoYear2(event.target.value);
						parentPostcropTwoYearTwoChange(event.target.value);
					},
				},
				{
					crop: postCropThreeYear2,
					changeHandler: (event) => {
						setPostCropThreeYear2(event.target.value);
						parentPostcropThreeYearTwoChange(event.target.value);
					},
				},
			],
			[
				{
					crop: postCropOneYear3,
					changeHandler: (event) => {
						setPostCropOneYear3(event.target.value);
						parentPostcropOneYearThreeChange(event.target.value);
					},
				},
				{
					crop: postCropTwoYear3,
					changeHandler: (event) => {
						setPostCropTwoYear3(event.target.value);
						parentPostcropTwoYearThreeChange(event.target.value);
					},
				},
				{
					crop: postCropThreeYear3,
					changeHandler: (event) => {
						setPostCropThreeYear3(event.target.value);
						parentPostcropThreeYearThreeChange(event.target.value);
					},
				},
			],
		],
	};

	function getInitialCropValue(fromFieldDetails, fromParent) {
		return fromFieldDetails == "" || fromFieldDetails != fromParent ? fromParent : fromFieldDetails;
	}

	function propsHasMultipleCrops(isPre) {
		let cropList;
		if (isPre) {
			cropList = [
				fieldDetails.precropping.preyearcroptwoyearone,
				fieldDetails.precropping.preyearcropthreeyearone,
				fieldDetails.precropping.preyearcroptwoyeartwo,
				fieldDetails.precropping.preyearcropthreeyeartwo,
				fieldDetails.precropping.preyearcroptwoyearthree,
				fieldDetails.precropping.preyearcropthreeyearthree,
			];
		} else {
			cropList = [
				fieldDetails.postcropping.postyearcroptwoyearone,
				fieldDetails.postcropping.postyearcropthreeyearone,
				fieldDetails.postcropping.postyearcroptwoyeartwo,
				fieldDetails.postcropping.postyearcropthreeyeartwo,
				fieldDetails.postcropping.postyearcroptwoyearthree,
				fieldDetails.postcropping.postyearcropthreeyearthree,
			];
		}
		return cropList.some((crop) => crop && crop !== "1"); //lookup id 1 is "No Selection"
	}

	useEffect(() => {
		fetch(CMBYN.FETCH_CROPLOOKUP)
			.then((response) => response.json())
			.then((results) => {
				var list = [];
				for (var u = 0; u < results.length; u++) {
					let usr = results[u];
					if (usr) {
						let option = {};
						option.name = usr.name;
						option.id = usr.id;
						list.push(option);
					}
				}
				setCropList(list);
			});
	}, []);

	return (
		<GridContainer direction="column" justifyContent="flex-start" alignItems="flex-start">
			<GridItem
				id="cropExplainerText"
				xs={12}
				style={
					{
						/*width: "0", minWidth: "100%"*/
					}
				}
			>
				<p style={{ marginTop: 0 }}>
					Enter your cropping system for the three years prior to and following your proposed irrigation system
					enhancement.
				</p>
				<p>
					If you grew more than one crop in a single year, check the box labeled "I have rotational crops" and select a
					crop for Crop 2 and/or Crop 3.
				</p>
				<p>
					If growing a perennial or continuous crop, use <i>copy this crop to all years</i>, to copy to every year.
				</p>
				<p>
					You must have at least one crop selected for each year. If the field was fallow, please select <i>Fallow</i>.
				</p>
			</GridItem>

			<div
				id="cropDataEntryArea"
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-around",
					width: "100%",
					flexWrap: "wrap",
					gap: 16,
				}}
			>
				{Object.entries(cropYearPeriods).map(([periodKey, years]) => {
					const isPre = periodKey === "Pre";
					const hasMultipleCrops = isPre ? hasMultiplePreCrops : hasMultiplePostCrops;
					const setHasMultipleCrops = isPre ? setHasMultiplePreCrops : setHasMultiplePostCrops;
					const periodTitle = periodKey + "-Project";
					const columnWidth = 190;

					return (
						<React.Fragment key={periodKey}>
							<div id={periodTitle} style={{ display: "flex", flexDirection: "column" }}>
								<Typography style={{ fontSize: "1.5rem", fontWeight: "400" }}>{periodTitle}</Typography>

								{!hasMultipleCrops && (
									<div style={{ marginTop: "5px" }}>
										<FormControlLabel
											control={
												<Checkbox
													checked={hasMultipleCrops}
													onChange={(_, checked) => setHasMultipleCrops(checked)}
													color="primary"
												/>
											}
											label="I have rotational crops"
											className="MuiFormLabel-root"
										/>
										<Tooltip
											classes={tooltipClasses}
											title="A rotation crop is a crop in which you will be planting and harvesting those crops within the same field multiple times per year. You can indicate up to three rotational crops per year."
											placement="top"
											arrow
										>
											<HelpIcon color="primary" style={{ fontSize: 18, verticalAlign: "middle" }} />
										</Tooltip>
									</div>
								)}

								{years.map((yearCrops, yearIndex) => {
									const yearNumber = yearIndex + 1;
									const yearLabel = `Year ${yearNumber}:`;
									const id = `${periodKey.toLowerCase()}CropRow${yearNumber}`;
									const cropAgeId = `${periodKey}Year${yearNumber}CropAge`;

									return (
										<div
											key={yearIndex}
											style={{
												display: "flex",
												flexDirection: "row",
												gap: 5,
												alignItems: "flex-start",
												justifyContent: "flex-start",
												marginTop: yearIndex === 0 ? 10 : 30,
											}}
										>
											<InputLabel variant="standard" color="primary" style={{ textWrap: "nowrap" }}>
												{yearLabel}
											</InputLabel>
											<div>
												<div
													key={id}
													id={id}
													style={{
														display: "flex",
														flexDirection: "row",
														gap: 8,
													}}
												>
													{yearCrops.map((cropData, cropIndex) => {
														const cropNumber = cropIndex + 1;
														const cropLabel = cropIndex === 0 ? `Crop ${cropNumber}` : `Crop ${cropNumber} (if any)`;
														const cropId = `${periodKey}Crop${cropNumber}Year${yearNumber}`;

														return (
															(cropIndex === 0 || hasMultipleCrops) && (
																<div
																	key={cropId}
																	style={{
																		width: columnWidth,
																	}}
																>
																	<InputLabel htmlFor={cropId}>{cropLabel}</InputLabel>
																	<NativeSelect
																		id={cropId}
																		value={cropData.crop}
																		onChange={cropData.changeHandler}
																		input={<BootstrapInput />}
																	>
																		{cropList.map((cr) => (
																			<option key={cr.name} value={cr.id}>
																				{cr.name}
																			</option>
																		))}
																	</NativeSelect>

																	{yearIndex === 0 && cropData.copyHandler && (
																		<Link
																			id={`copy${periodKey}Crop${cropNumber}V`}
																			component="button"
																			variant="body2"
																			onClick={cropData.copyHandler}
																			style={{ fontSize: "small", marginTop: 5 }}
																		>
																			<a
																				title={`Click to Copy Crop ${cropNumber} to Year 2 and Year 3`}
																				style={{ display: "flex", alignItems: "center" }}
																			>
																				<ArrowDownwardIcon />
																				Copy this crop to all years
																			</a>
																		</Link>
																	)}
																</div>
															)
														);
													})}

													{/* Crop Age column */}
													{/* <div style={{ width: columnWidth, flexShrink: 0 }}>
														<InputLabel htmlFor={cropAgeId}>
															{`Crop age${hasMultipleCrops ? "s" : ""} (optional)`}
															<Tooltip
																classes={tooltipClasses}
																title="Please indicate the approximate age of your crop.  If you are growing a rotational field crop, you can indicate approximately how many months it will be growing during the year. If it’s a permanent crop, indicate approximately how many years old the permanent crop is."
																placement="top"
																arrow
															>
																<HelpIcon
																	style={{ fontSize: 18, marginLeft: 4, verticalAlign: "middle", color: "#888" }}
																/>
															</Tooltip>
														</InputLabel>

														<TextField
															variant="outlined"
															size="small"
															value={isPre ? preCropAges[yearIndex] : postCropAges[yearIndex]}
															onChange={(e) => {
																let newAges;
																if (isPre) {
																	newAges = [...preCropAges];
																	newAges[yearIndex] = e.target.value;
																	setPreCropAges(newAges);
																} else {
																	newAges = [...postCropAges];
																	newAges[yearIndex] = e.target.value;
																	setPostCropAges(newAges);
																}
																handleCropAgeChange(newAges, isPre);
															}}
															style={{ marginTop: 16 }}
														/>
													</div> */}
												</div>

												{/* Crop Age row */}
												<div style={{ width: "100%", marginTop: 16 }}>
													<InputLabel htmlFor={cropAgeId}>
														{`Crop age${hasMultipleCrops ? "s" : ""} (optional)`}
														<Tooltip
															classes={tooltipClasses}
															title="Please indicate the approximate age of your crop.  If you are growing a rotational field crop, you can indicate approximately how many months it will be growing during the year. If it’s a permanent crop, indicate approximately how many years old the permanent crop is."
															placement="top"
															arrow
														>
															<HelpIcon
																color="primary"
																style={{ fontSize: 18, marginLeft: 4, verticalAlign: "middle" }}
															/>
														</Tooltip>
													</InputLabel>

													<TextField
														variant="outlined"
														size="small"
														value={isPre ? preCropAges[yearIndex] : postCropAges[yearIndex]}
														onChange={(e) => {
															if (isPre) {
																const newAges = [...preCropAges];
																newAges[yearIndex] = e.target.value;
																setPreCropAges(newAges);
															} else {
																const newAges = [...postCropAges];
																newAges[yearIndex] = e.target.value;
																setPostCropAges(newAges);
															}
														}}
														style={{ marginTop: 8, width: "100%" }}
													/>
												</div>
											</div>
										</div>
									);
								})}
							</div>

							{periodKey === "Pre" && <div className="vertical-divider" />}
						</React.Fragment>
					);
				})}
			</div>

			{/* todo: check the biggest max-width breakpoint on larger screens - we should be able to decrease it now that crop ages are in their own row */}
			<style>{`
				.vertical-divider {
					height: auto;
					width: 2px;
					background: #e0e0e0;
					margin: 0 12px;
					align-self: stretch;
				}
				@media (max-width: ${
					hasMultiplePreCrops && hasMultiplePostCrops ? 1463 : hasMultiplePreCrops || hasMultiplePostCrops ? 1145 : 820
				}px) {
					#cropDataEntryArea {
						flex-direction: column !important;
					}
					.vertical-divider {
						display: none;
					}
				}
			`}</style>
		</GridContainer>
	);
}
